/* eslint-disable no-unused-vars */ 

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-global-loader.html";

export class NsGlobalLoader extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "ns-global-loader";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      open: {
        type: Boolean,
        value: false
      },
      /**
       * ID of the z-index setter function timeout
       * @private
       */
      _timeoutId: {
        type: Number,
        value: -1
      }
    };
  }

  isOpen(open) {
    if (!open) {
      this._timeoutId = setTimeout(() => {
        this.$.loader.style.zIndex = "-1";
        this.$.loader.style.display = "none";
      }, 300);
      return "";
    } else {
      this.$.loader.style.zIndex = "10000";
      this.$.loader.style.display = "block";
      clearTimeout(this._timeoutId);
      return "open";
    }
  }

  ready() {
    super.ready();
  }
}
customElements.define(NsGlobalLoader.is, NsGlobalLoader);
